"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.getStrideForLayout = getStrideForLayout;
exports.transformGeom2D = transformGeom2D;

var _Geometry = _interopRequireDefault(require("./Geometry.js"));

var _GeometryLayout = _interopRequireDefault(require("./GeometryLayout.js"));

var _util = require("../util.js");

var _extent = require("../extent.js");

var _transform = require("./flat/transform.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/geom/SimpleGeometry
 */


/**
 * @classdesc
 * Abstract base class; only used for creating subclasses; do not instantiate
 * in apps, as cannot be rendered.
 *
 * @abstract
 * @api
 */
var SimpleGeometry =
/** @class */
function (_super) {
  __extends(SimpleGeometry, _super);

  function SimpleGeometry() {
    var _this = _super.call(this) || this;
    /**
     * @protected
     * @type {import("./GeometryLayout.js").default}
     */


    _this.layout = _GeometryLayout["default"].XY;
    /**
     * @protected
     * @type {number}
     */

    _this.stride = 2;
    /**
     * @protected
     * @type {Array<number>}
     */

    _this.flatCoordinates = null;
    return _this;
  }
  /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */


  SimpleGeometry.prototype.computeExtent = function (extent) {
    return (0, _extent.createOrUpdateFromFlatCoordinates)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
  };
  /**
   * @abstract
   * @return {Array<*> | null} Coordinates.
   */


  SimpleGeometry.prototype.getCoordinates = function () {
    return (0, _util["abstract"])();
  };
  /**
   * Return the first coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} First coordinate.
   * @api
   */


  SimpleGeometry.prototype.getFirstCoordinate = function () {
    return this.flatCoordinates.slice(0, this.stride);
  };
  /**
   * @return {Array<number>} Flat coordinates.
   */


  SimpleGeometry.prototype.getFlatCoordinates = function () {
    return this.flatCoordinates;
  };
  /**
   * Return the last coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} Last point.
   * @api
   */


  SimpleGeometry.prototype.getLastCoordinate = function () {
    return this.flatCoordinates.slice(this.flatCoordinates.length - this.stride);
  };
  /**
   * Return the {@link module:ol/geom/GeometryLayout layout} of the geometry.
   * @return {import("./GeometryLayout.js").default} Layout.
   * @api
   */


  SimpleGeometry.prototype.getLayout = function () {
    return this.layout;
  };
  /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   */


  SimpleGeometry.prototype.getSimplifiedGeometry = function (squaredTolerance) {
    if (this.simplifiedGeometryRevision !== this.getRevision()) {
      this.simplifiedGeometryMaxMinSquaredTolerance = 0;
      this.simplifiedGeometryRevision = this.getRevision();
    } // If squaredTolerance is negative or if we know that simplification will not
    // have any effect then just return this.


    if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance <= this.simplifiedGeometryMaxMinSquaredTolerance) {
      return this;
    }

    var simplifiedGeometry = this.getSimplifiedGeometryInternal(squaredTolerance);
    var simplifiedFlatCoordinates = simplifiedGeometry.getFlatCoordinates();

    if (simplifiedFlatCoordinates.length < this.flatCoordinates.length) {
      return simplifiedGeometry;
    } else {
      // Simplification did not actually remove any coordinates.  We now know
      // that any calls to getSimplifiedGeometry with a squaredTolerance less
      // than or equal to the current squaredTolerance will also not have any
      // effect.  This allows us to short circuit simplification (saving CPU
      // cycles) and prevents the cache of simplified geometries from filling
      // up with useless identical copies of this geometry (saving memory).
      this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
      return this;
    }
  };
  /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @protected
   */


  SimpleGeometry.prototype.getSimplifiedGeometryInternal = function (squaredTolerance) {
    return this;
  };
  /**
   * @return {number} Stride.
   */


  SimpleGeometry.prototype.getStride = function () {
    return this.stride;
  };
  /**
   * @param {import("./GeometryLayout.js").default} layout Layout.
   * @param {Array<number>} flatCoordinates Flat coordinates.
   */


  SimpleGeometry.prototype.setFlatCoordinates = function (layout, flatCoordinates) {
    this.stride = getStrideForLayout(layout);
    this.layout = layout;
    this.flatCoordinates = flatCoordinates;
  };
  /**
   * @abstract
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
   */


  SimpleGeometry.prototype.setCoordinates = function (coordinates, opt_layout) {
    (0, _util["abstract"])();
  };
  /**
   * @param {import("./GeometryLayout.js").default|undefined} layout Layout.
   * @param {Array<*>} coordinates Coordinates.
   * @param {number} nesting Nesting.
   * @protected
   */


  SimpleGeometry.prototype.setLayout = function (layout, coordinates, nesting) {
    /** @type {number} */
    var stride;

    if (layout) {
      stride = getStrideForLayout(layout);
    } else {
      for (var i = 0; i < nesting; ++i) {
        if (coordinates.length === 0) {
          this.layout = _GeometryLayout["default"].XY;
          this.stride = 2;
          return;
        } else {
          coordinates =
          /** @type {Array} */
          coordinates[0];
        }
      }

      stride = coordinates.length;
      layout = getLayoutForStride(stride);
    }

    this.layout = layout;
    this.stride = stride;
  };
  /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   */


  SimpleGeometry.prototype.applyTransform = function (transformFn) {
    if (this.flatCoordinates) {
      transformFn(this.flatCoordinates, this.flatCoordinates, this.stride);
      this.changed();
    }
  };
  /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */


  SimpleGeometry.prototype.rotate = function (angle, anchor) {
    var flatCoordinates = this.getFlatCoordinates();

    if (flatCoordinates) {
      var stride = this.getStride();
      (0, _transform.rotate)(flatCoordinates, 0, flatCoordinates.length, stride, angle, anchor, flatCoordinates);
      this.changed();
    }
  };
  /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [opt_sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [opt_anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   */


  SimpleGeometry.prototype.scale = function (sx, opt_sy, opt_anchor) {
    var sy = opt_sy;

    if (sy === undefined) {
      sy = sx;
    }

    var anchor = opt_anchor;

    if (!anchor) {
      anchor = (0, _extent.getCenter)(this.getExtent());
    }

    var flatCoordinates = this.getFlatCoordinates();

    if (flatCoordinates) {
      var stride = this.getStride();
      (0, _transform.scale)(flatCoordinates, 0, flatCoordinates.length, stride, sx, sy, anchor, flatCoordinates);
      this.changed();
    }
  };
  /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */


  SimpleGeometry.prototype.translate = function (deltaX, deltaY) {
    var flatCoordinates = this.getFlatCoordinates();

    if (flatCoordinates) {
      var stride = this.getStride();
      (0, _transform.translate)(flatCoordinates, 0, flatCoordinates.length, stride, deltaX, deltaY, flatCoordinates);
      this.changed();
    }
  };

  return SimpleGeometry;
}(_Geometry["default"]);
/**
 * @param {number} stride Stride.
 * @return {import("./GeometryLayout.js").default} layout Layout.
 */


function getLayoutForStride(stride) {
  var layout;

  if (stride == 2) {
    layout = _GeometryLayout["default"].XY;
  } else if (stride == 3) {
    layout = _GeometryLayout["default"].XYZ;
  } else if (stride == 4) {
    layout = _GeometryLayout["default"].XYZM;
  }

  return (
    /** @type {import("./GeometryLayout.js").default} */
    layout
  );
}
/**
 * @param {import("./GeometryLayout.js").default} layout Layout.
 * @return {number} Stride.
 */


function getStrideForLayout(layout) {
  var stride;

  if (layout == _GeometryLayout["default"].XY) {
    stride = 2;
  } else if (layout == _GeometryLayout["default"].XYZ || layout == _GeometryLayout["default"].XYM) {
    stride = 3;
  } else if (layout == _GeometryLayout["default"].XYZM) {
    stride = 4;
  }

  return (
    /** @type {number} */
    stride
  );
}
/**
 * @param {SimpleGeometry} simpleGeometry Simple geometry.
 * @param {import("../transform.js").Transform} transform Transform.
 * @param {Array<number>} [opt_dest] Destination.
 * @return {Array<number>} Transformed flat coordinates.
 */


function transformGeom2D(simpleGeometry, transform, opt_dest) {
  var flatCoordinates = simpleGeometry.getFlatCoordinates();

  if (!flatCoordinates) {
    return null;
  } else {
    var stride = simpleGeometry.getStride();
    return (0, _transform.transform2D)(flatCoordinates, 0, flatCoordinates.length, stride, transform, opt_dest);
  }
}

var _default = SimpleGeometry;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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